<template>
    <div class="scd__settings--panel">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'SkyChartSettingsPanel'
}
</script>

<style>

</style>